import styled from '@emotion/styled';
import React from 'react';

import type { LensDivProps } from '../../types';
import {
  getColorValue,
  getFontWeight,
  getRadius,
  getSize,
  getTextSize,
  u,
} from '../../utilities';

import Container from '../container/container';
import Icon from '../icon/icon';

const PillWrapper = styled.div<PillWrapperProps>`
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  vertical-align: middle;
  padding: 0 ${u(1.5)};
  min-height: ${u(3.25)};
  color: ${props => getColorValue(props.color)};
  background-color: ${props => getColorValue(props.backgroundColor)};
  ${getRadius('100')};
  ${getTextSize('small')};
  ${getFontWeight('bold')};
  ${getSize('gap', 'xsmall')};
`;

const Pill = ({
  color,
  backgroundColor,
  children,
  icon,
  iconPosition = 'left',
  ...props
}: PillProps &
  React.ComponentProps<typeof PillWrapper> &
  Omit<
    LensDivProps,
    keyof PillProps & React.ComponentProps<typeof PillWrapper>
  >) => {
  const iconComponent = (
    <Container
      htmlTag="span"
      paddingLeft={iconPosition === 'right' && 'xsmall'}
      paddingRight={iconPosition === 'left' && 'xsmall'}
    >
      <Icon icon={icon} color="currentColor" size={2} />
    </Container>
  );

  return (
    <PillWrapper color={color} backgroundColor={backgroundColor} {...props}>
      {icon && iconPosition === 'left' && iconComponent}
      {children}
      {icon && iconPosition === 'right' && iconComponent}
    </PillWrapper>
  );
};

type PillProps = {
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  color?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
};

type PillWrapperProps = {
  color?: string;
  backgroundColor?: string;
};

export default Pill;
